import { forwardRef } from 'react';

export const Button = forwardRef(function Button({
  children,
  type = 'button',
  tone = 'primary',
  disabled = false,
  loading = false,
  className,
  ...props
}, ref) {
  return (
    <button
      ref={ref}
      type={type}
      className={['btn', `btn-${tone}`, className].filter(Boolean).join(' ')}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...props}
    >
      {loading ? <span className="sr-only" role="status">{typeof children === 'string' ? children : ''}</span> : null}
      {loading ? <span className="btn-spinner" aria-hidden="true" /> : null}
      <span>{children}</span>
    </button>
  );
});
